import axios from 'axios'
import store from '../store'
import qs from 'qs'

var client = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,
  paramsSerializer: function (params) {
    return qs.stringify(params, {indices: false})
  }

})

client.interceptors.request.use(function (config) {
  if (document.cookie) {
    const csrfCookie = document.cookie.split(';').find((c) => { return c.trim().startsWith('csrftoken=') })
    if (csrfCookie) {
      const csrfToken = csrfCookie.split('=')[1]
      config.headers['X-CSRFToken'] = csrfToken
    }
  }

  const demo = store.state.demo
  if (demo) {
    config.headers['DEMO'] = 1
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

export { client }

export default {
  client: client,
  status: function () {
    return client.get('/status')
  },
  acceptPrivacyPolicy () {
    return client.post(`/privacy-policy/acceptance`)
  },
  login: function (username, password) {
    store.dispatch('logOutUser')
    return client.post('/login', {
      email: username,
      password: password
    },
      {
        headers: {
          credentials: 'include'
        }
      }).then(
        response => {
          window.localStorage.token = response.data.token
        }
    )
  },
  logout: function () {
    return client.get('/logout')
      .then(
        () => {
          store.dispatch('logOutUser')
        })
  },
  magicLogin: function (hash) {
    return client.get(`/magic-link/${hash}`)
  },
  forgotPassword: function (body) {
    return client.post('/forgot-password/', body)
  },
  checkPasswordResetToken: function (token) {
    return client.get('/reset-password/', {
      params: {et: token}
    })
  },
  submitPasswordReset: function (body) {
    return client.post('/reset-password/', body)
  },
  currentUser: function () {
    return client.get('/users/me')
  },
  hijackUser: function (id) {
    return client.post(`/hijack/${id}/`)
  },
  releaseHijack: function () {
    return client.post('/hijack/release-hijack/')
  },
  getBrand: function (brand) {
    return client.get(`/brands/${brand}`)
  },
  listBrands: function (search, limit, source) {
    let token
    if (source) {
      token = source.token
    }

    return client.get(`/brands/`, {params: {search: search, limit: limit, is_hidden: false}, cancelToken: token})
  },
  getSocialStats: function (docId, metricDays) {
    return client.get(`/social-stats/${docId}`, {params: {metricDays: metricDays}})
  },
  getSocialStatsWithBrand: function (pageUrlId, brandId, metricDays) {
    return client.get(`/social-stats/${pageUrlId}`, {params: {
      metricDateRange: metricDays,
      brandId
    }})
  },
  getConversionStats: function (docId, metricDays) {
    return client.get(`/conversion-stats/${docId}`, {params: {metricDays: metricDays}})
  },
  getConversionStatsWithBrandId: function (pageUrlId, brandId, metricDays) {
    const params = {
      metricDateRange: metricDays,
      brandId
    }
    return client.get(`/conversion-stats/${pageUrlId}`, { params })
  },
  listUsers: function (query) {
    return client.get('/users/', {params: {search: query}})
  },
  getUser: function (id) {
    return client.get(`/users/${id}`)
  },
  getCompletionStats: function (docId, metricDays) {
    return client.get(`/completion-stats/${docId}`, {params: {metricDays: metricDays}})
  },
  getCompletionStatsWithBrandId: function (pageUrlId, brandId, metricDays) {
    return client.get(`/completion-stats/${pageUrlId}`, { params: {
      metricDateRange: metricDays,
      brandId
    }})
  },
  getBrandPublic: function (brandId) {
    return client.get(`/public/brands/${brandId}`)
  },
  getPageViewStats: (assetId, metricDays) => {
    if (metricDays) {
      return client.get(`/articles/${assetId}/stats`, {params: {metricDateRange: metricDays}})
    } else {
      return client.get(`/articles/${assetId}/stats`)
    }
  },
  getPageViewStatsWithBrandId (pageUrlId, brandId, metricDays) {
    const params = {
      metricDateRange: metricDays,
      brandId
    }
    return client.get(`/articles/${pageUrlId}/stats`, { params })
  },
  getTaskCount: (taskId) => {
    return client.get(`/get-task-counter/${taskId}`)
  },
  getCampaignDetail: (campaignId, adType) => {
    return client.get(`campaign-dashboard/${campaignId}`, {params: {adType: adType}})
  }
}
